import { type Json } from '../core/index.js';
import { clearStorage } from './clear-storage.js';
import { clearStorageSync } from './clear-storage-sync.js';
import { type FabricStorageGetStorageApi, getStorage } from './get-storage.js';
import {
  type FabricStorageGetStorageInfoApi,
  getStorageInfo,
} from './get-storage-info.js';
import {
  type FabricStorageGetStorageSyncInfoApi,
  getStorageInfoSync,
} from './get-storage-info-sync.js';
import {
  type FabricStorageGetStorageSyncApi,
  getStorageSync,
} from './get-storage-sync.js';
import { removeStorage } from './remove-storage.js';
import { removeStorageSync } from './remove-storage-sync.js';
import { setStorage } from './set-storage.js';
import { setStorageSync } from './set-storage-sync.js';

export type FabricStorageApi = {
  /**
   * 清理本地数据缓存
   */
  clearStorage: () => Promise<boolean>;
  /**
   * 同步接口, 清理本地数据缓存
   */
  clearStorageSync: () => boolean;
  /**
   * 异步获取当前storage的相关信息
   */
  getStorageInfo: FabricStorageGetStorageInfoApi;
  /**
   * 同步接口, 获取当前storage的相关信息
   */
  getStorageInfoSync: FabricStorageGetStorageSyncInfoApi;
  /**
   * 从本地缓存中异步获取指定 key 的内容
   */
  getStorage: FabricStorageGetStorageApi;
  /**
   * 同步接口, 从本地缓存中同步获取指定 key 的内容
   */
  getStorageSync: FabricStorageGetStorageSyncApi;
  /**
   * 从本地缓存中移除指定 key。
   */
  removeStorage: (key: string) => Promise<boolean>;
  /**
   * 同步接口, 从本地缓存中移除指定 key。
   */
  removeStorageSync: (key: string) => boolean;
  /**
   * 将数据存储在本地缓存中指定的 key 中。会覆盖掉原来该 key 对应的内容。除非用户主动删除或因存储空间原因被系统清理，否则数据都一直可用。单个 key 允许存储的最大数据长度为 1MB，所有数据存储上限为 10MB。
   */
  setStorage: (key: string, data: Json) => Promise<boolean>;
  /**
   * 同步接口, 将数据存储在本地缓存中指定的 key 中。会覆盖掉原来该 key 对应的内容。除非用户主动删除或因存储空间原因被系统清理，否则数据都一直可用。单个 key 允许存储的最大数据长度为 1MB，所有数据存储上限为 10MB。
   */
  setStorageSync: (key: string, data: Json) => boolean;
};

export const fabricStorage: FabricStorageApi = {
  clearStorage,
  clearStorageSync,
  getStorageInfo,
  getStorageInfoSync,
  getStorage,
  getStorageSync,
  removeStorage,
  removeStorageSync,
  setStorage,
  setStorageSync,
};
